import { GET_QUOTE_HREF, GET_QUOTE_LABEL } from '../constants/quote';

export const javaTutoringOffer = {
  title: 'Java tutoring & guided debugging',
  quoteHref: GET_QUOTE_HREF,
  quoteLabel: GET_QUOTE_LABEL,
  unit: 'per 60-minute online session',
  description: 'Get comfortable with Java, understand your code, and work through problems with a developer.',
  includes: [
    'Java fundamentals and object-oriented programming',
    'Guided debugging and practical explanations',
    'A focused session built around your questions',
  ],
  note: 'Bring your code or questions. Sessions focus on learning and solving problems together.',
  action: 'Request a Java session',
  subject: 'Java tutoring enquiry',
  body:
    'Hi RosuePro,\n\nI would like a Java session.\nTopics or problem: \nExperience level: \nPreferred time: ',
};
